// 従業員側でのみ使用するhooks
import { gql, useQuery } from '@apollo/client';

type QueryResult = {
  year: number;
};

const FETCH_YEAR = gql`
  query year {
    year
  }
`;

export const useYear = () => {
  const { data, loading } = useQuery<QueryResult>(FETCH_YEAR);
  return { loading, year: data?.year };
};
